(function() {
  'use strict';

  angular.module('ringbaPortal').directive('tagSelector', tagSelector);

  function tagSelector(
    _,
    $timeout,
    $window
  ) {
    'ngInject';

    const directive = {
      restrict: 'E',
      require: ['tagSelector', '^ngModel'],
      scope: {
        availableTags: '<',
        formNameForUserSettings: '@',
        tagId: '<',
        tagIds: '<',
        filter: '<',
        andIndex: '<',
        orIndex: '<',
        bulkTagUploads: '<',
        selectedBulkTagUpload: '<',
        isStreamlinedZipcodeActive: '<',
        comparisonNegativeMatch: '<',
        changeComparisonType: '<', // callback function
        onTagChange: '&',
        onNewUpload: '&'
      },
      replace: true,
      link: link,
      templateUrl: '/scripts/shared/directives/tag-selector/tag-selector.view.html',
      controller: 'TagSelectorController',
      controllerAs: 'vm',
      bindToController: true
    };
    return directive;

    function link(scope, element, attributes, controllers) {
      const $tagSelectCtrl = controllers[0],
        ngModelCtrl = controllers[1],
        searchField = element.find('input[type="search"]');
      let tabContentMaxHeight;

      $tagSelectCtrl.setNgModelController(ngModelCtrl);
      $tagSelectCtrl.handleEnableSearch = handleEnableSearch;
      $window.document.addEventListener('click', _onDocumentClick, true);
      $window.document.addEventListener('keydown', _bindEscTabKeyPress, true);
      scope.$on('$destroy', _onScopeDestroy);

      // View to model
      ngModelCtrl.$parsers.unshift(function (inputValues) {
        const values = [];
        inputValues.forEach(function (inputValue) {
          values.push(inputValue.tagType + ':' + inputValue.tagName);
        });
        return values;
      });

      // Model to view
      ngModelCtrl.$formatters.unshift(function (inputValues) {
        if ($tagSelectCtrl.availableTags && $tagSelectCtrl.availableTags.length) {
          return _.filter($tagSelectCtrl.availableTags, function (tag) {
            const found = _.findIndex(inputValues, function (inputValue) {
              return (tag.tagType + ':' + tag.tagName) === inputValue;
            });

            return found != -1;
          });
        }
      });

      element.find('.tag-selector-search').on('focus', function() {
        if (!$tagSelectCtrl.searchEnabled) {
          $tagSelectCtrl.enableSearch();
        }
      });

      function handleEnableSearch () {
        $timeout(function () {
          searchField.focus();
          if (!tabContentMaxHeight) {
            const tabsContainer = element.find('.tag-selector-tabs-container');
            tabContentMaxHeight = tabsContainer.outerHeight() + 100;
            tabsContainer.find('.tab-content').css({
              'height': tabContentMaxHeight + 'px'
            });
          }
        });
      }

      function _bindEscTabKeyPress(evt) {
        if (!$tagSelectCtrl.searchEnabled) {
          return;
        }

        let isEscape,
          isTab;
        if ('key' in evt) {
          isEscape = (evt.key === 'Escape' || evt.key === 'Esc');
          isTab = (evt.key === 'Tab');
        } else {
          isEscape = (evt.keyCode === 27 || evt.keyCode === 9);
          isTab = (evt.keyCode === 9);
        }
        if (isEscape) {
          _closeDropdown();
        }

        if (isTab) {
          $timeout(function () {
            if (!$.contains(element[0], document.activeElement)) {
              _closeDropdown();
            }
          });
        }
      }

      function _onDocumentClick(e) {

        if (!$tagSelectCtrl.searchEnabled) {
          return;
        }

        if (!$.contains(element[0], e.target) && !_checkIfBulkTagsUploadInput(e.target)) {
          _closeDropdown();
        }
      }

      function _checkIfBulkTagsUploadInput(element) {
        return element.type === 'file' && element.name == 'bulk-tags-file';
      }

      function _closeDropdown() {
        $tagSelectCtrl.searchEnabled = false;
        $tagSelectCtrl.searchTagId = '';
        $tagSelectCtrl.searchFilteredTags = [];
        _resetActiveTab();
        _setTouched();
        scope.$digest();
      }

      function _resetActiveTab() {
        Object.getOwnPropertyNames($tagSelectCtrl.isStreamlinedZipcodeActive).forEach(function (tab) {
          $tagSelectCtrl.isStreamlinedZipcodeActive[tab] = false;
        });
      }

      function _setTouched() {
        if (!ngModelCtrl.$touched) {
          ngModelCtrl.$setTouched();
        }
      }

      function _onScopeDestroy() {
        $window.document.removeEventListener('click', _onDocumentClick, true);
        $window.document.removeEventListener('keydown', _bindEscTabKeyPress, true);
      }
    }

  }

})();
